export var loadingItem = '<div class="loadingItem"></div>';
export var modalInfo = $('#modal-info');
export var modalAction = $('#modal-action');
export var modalTitle = "Event Link";
export const isTld = require('is-tld')
// export var emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export var emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
// export var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export var text = {
    'error': 'エラー',
    'invalidRequired': '情報を入力してください。',
    'invalidEmail': '有効なメールアドレス形式で指定してください。',
    'confirmDelete': 'この操作は取り消せませんがよろしいですか？',
    'invalidKana': '申込者の名(カナ)は全角カタカナで入力してください。',
}
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
// remove status confirm of delete
modalAction.on('hidden.bs.modal', function(e) {
    e.preventDefault();
    modalAction.find('.modal-footer').find('input#action-id').remove();
    modalAction.find('.btn[data-choose="ok"]').removeAttr('data-type').removeAttr('data-module');

    setTimeout(function() {
        $('[data-confirm-delete]').removeAttr('data-confirm-delete');
    }, 1000);
});
export function scrollTo(element) {
    $([document.documentElement, document.body]).animate({
        scrollTop: element.offset().top - 100
    }, 800);
}
export function showLoading(parentContainer) {
    parentContainer.append(loadingItem);
}
export function hideLoading() {
    $('.loadingItem').remove();
}
export function showModal(modalAction, modalTitle, modalBody) {
    modalAction.find('.modal-title').html(modalTitle);
    modalAction.find('.modal-body').html(modalBody);
    modalAction.modal('show');
}
export function invalidDiv(message) {
    return '<div class="d-block mt-1 invalid-message"><span class="bg-warning text-danger pl-2 pr-2">' + message + '</span></div>';
}
export function appendInvalidDiv(wrap, message) {
    if (wrap.find('.invalid-message').length > 0) {
        wrap.find('.invalid-message').remove();
    }
    wrap.append(invalidDiv(message));
}
export function removeInvalidDiv(wrap) {
    wrap.find('.invalid-message').remove();
}
export function convertJsonData(frmData) {
    var arr = {};
    $.each(frmData, function(index, item) {
        var key = item.name;
        var value = item.value;
        // obj.items.push({ name : value });
        arr[key] = value;
    });
    return $.parseJSON(JSON.stringify(arr));
}
export function getConfirmDelete(actionType) {
    var modalBody = text.confirmDelete;
    modalAction.find('.modal-footer').find('.btn[data-choose="ok"]').attr('data-type', actionType).html('削除');
    showModal(modalAction, modalTitle, modalBody);
}
export function getUrlVars() {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
export function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('(\\?|\\&)(' + paramName + '=).*?(&|$)')
    var newUrl = url
    if (url.search(pattern) >= 0) {
        newUrl = url.replace(pattern, '$1$2' + paramValue + '$3');
    } else {
        newUrl = newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue
    }
    return newUrl
}
export function checkKana(str) {
    if (str.match(/^[ァ-ロワヲンー 　\r\n\t]*$/)) {
        return true;
    } else {
        return false;
    }
}
export function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
}
// form element checkbox
$('body').on('click', '.form-element[type="checkbox"]', function() {
    var checkboxIndex = $(this).parent().find('.form-element-checkbox-index');
    // var feIndex = $(this).attr('data-index');
    if ($(this).is(':checked')) {
        checkboxIndex.val(checkboxIndex.val() + $(this).val() + ',');
    } else {
        checkboxIndex.val(checkboxIndex.val().replace($(this).val() + ',', ''));
    }
});
// contact
$('body').on('click', '#modal-contact .btn[data-choose="ok"]', function(e) {
    e.preventDefault();
    var contactNameInput = $('input[name="contact_name"]');
    var contactEmailInput = $('input[name="contact_email"]');
    var contactContentTextearea = $('textarea[name="contact_content"]');
    if (contactNameInput.val().trim().length == 0) {
        appendInvalidDiv(contactNameInput.parent(), text.invalidRequired);
    } else {
        removeInvalidDiv(contactNameInput.parent());
    }
    if (!isValidEmailAddress(contactEmailInput.val().trim())) {
        appendInvalidDiv(contactEmailInput.parent(), text.invalidEmail);
    } else {
        removeInvalidDiv(contactEmailInput.parent());
    }
    if (contactContentTextearea.val().trim().length == 0) {
        appendInvalidDiv(contactContentTextearea.parent(), text.invalidRequired);
    } else {
        removeInvalidDiv(contactContentTextearea.parent());
    }
    if (($('.invalid-message').length == 0)) {
        $('input[name="contact_name"]').prop('disabled', true);
        $('input[name="contact_email"]').prop('disabled', true);
        $('textarea[name="contact_content"]').prop('disabled', true);

        $('#modal-contact .btn[data-choose="ok"]').addClass('d-none');
        $('#modal-contact .btn[data-choose="cancel"]').addClass('d-none');
        $('#modal-contact .btn[data-choose="return-input"]').removeClass('d-none');
        $('#modal-contact .btn[data-choose="submit"]').removeClass('d-none');
    }
});
$('body').on('click', '#modal-contact .btn[data-choose="return-input"]', function(e) {
    $('input[name="contact_name"]').prop('disabled', false);
    $('input[name="contact_email"]').prop('disabled', false);
    $('textarea[name="contact_content"]').prop('disabled', false);

    $('#modal-contact .btn[data-choose="ok"]').removeClass('d-none');
    $('#modal-contact .btn[data-choose="cancel"]').removeClass('d-none');
    $('#modal-contact .btn[data-choose="return-input"]').addClass('d-none');
    $('#modal-contact .btn[data-choose="submit"]').addClass('d-none');
});
$('body').on('click', '#modal-contact .btn[data-choose="submit"]', function(e) {
    var contactNameInput = $('input[name="contact_name"]');
    var contactEmailInput = $('input[name="contact_email"]');
    var contactContentTextearea = $('textarea[name="contact_content"]');
    $.ajax({
        url: '/contact',
        type: 'POST',
        dataType: 'json',
        data: {
            contact_name: contactNameInput.val().trim(),
            contact_email: contactEmailInput.val().trim(),
            contact_content: contactContentTextearea.val().trim(),
        },
        beforeSend: function() {
            showLoading($('#modal-contact'));
        },
        success: function(res) {
            hideLoading();
            if (res.status == 'error') {
                $.each(res.message, function(index, item) {
                    if (index == 'contact_name') {
                        appendInvalidDiv(contactNameInput.parent(), item);
                    }
                    if (index == 'contact_email') {
                        appendInvalidDiv(contactEmailInput.parent(), item);
                    }
                    if (index == 'contact_content') {
                        appendInvalidDiv(contactContentTextearea.parent(), item);
                    }
                });
            } else {
                $('#modal-contact').modal('hide');
                var message = '<p>Event Linkに関するお問い合わせは以下の専用フォームよりどうぞお気軽にお寄せください。担当者よりご連絡さしあげます。</p>';
                message += '<p>また、各イベントについてのお問い合わせはお答えできかねますので、イベント主催者の方へお問い合わせください。</p>';
                message += '<p>※お問い合わせ頂いた内容によってはお答え出来かねることがございます。あらかじめご了承ください。</p>';
                message += '<p>お問い合わせ内容を送信しました。担当者より近日中にご連絡さしあげますので、今しばらくお待ちください。</p>';
                showModal(modalInfo, modalTitle, message);
            }
        },
        error: function() {
            console.log('エラー');
        }
    });
});
$('#modal-contact').on('hidden.bs.modal', function(e) {
    $('input[name="contact_name"]').prop('disabled', false).val('');
    $('input[name="contact_email"]').prop('disabled', false).val('');
    $('textarea[name="contact_content"]').prop('disabled', false).val('');

    $('#modal-contact .btn[data-choose="ok"]').removeClass('d-none');
    $('#modal-contact .btn[data-choose="cancel"]').removeClass('d-none');
    $('#modal-contact .btn[data-choose="return-input"]').addClass('d-none');
    $('#modal-contact .btn[data-choose="submit"]').addClass('d-none');
});

export function breakStr() {
    var floating_text = $('.floating-banner p').text().trim().length;;
    var text = $('.floating-banner p').text().trim();
    var sub_str = '';
    if (floating_text >= 12) {
        sub_str += text.substring(0, 12) + '\n' + text.substring(12, 24);
    } else {
        sub_str = $('.floating-banner p').text();
    }

    $('.floating-banner p').html(sub_str);

    /*
   var text = $('.floating-banner p').text();
   var subText = text;
   var htmlStr = '';
   if (text.length <= 12) {
        htmlStr = text;
   } else {
        do {
            htmlStr += subText.substr(0, 12);
            if (subText.length >= 12) {
                htmlStr += '\n';
            }
            subText = subText.substr(11);
        } while (subText.length > 0)
   }
   $('.floating-banner p').html(htmlStr);
   //$('.floating-banner').removeClass('d-none');
   */
}
export function breakStrButton() {
    var btn_text_length = $('.btn-register').html().trim().length;;
    var text = $('.btn-register').html().trim();
    
    var sub_str = '';
    if (btn_text_length >= 12) {
        sub_str += text.substring(0, 12) + '<br/>' + text.substring(12, 24);
    } else {
        sub_str = $('.btn-register').html();
    }
    $('.btn-register').html(sub_str);
}
export function isEmail(email) {
	return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test( email );	
}
export function getDomain(email) {
    return email.substring(email.lastIndexOf("@") + 1);
}
export function getTld(domain) {
    return domain.substring(domain.lastIndexOf(".") + 1);
}
export function getTldEmail(email) {
    var domain = getDomain(email);
    return getTld(domain);
}
export function ValidateEmail(mail) {
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
        if (isTld(getTldEmail(mail)) == true) {
            //  [ dash before @ ] [ dot before @ ] [double dots are not allowed]
            // if (mail.indexOf('-@') > -1 || mail.indexOf('.@') > -1 || mail.indexOf('..') > -1) { 
            if (mail.indexOf('..') > -1 || mail.slice(0,1) == ".") { 
                 return false;
            }
            return true;
        } else {
            return false;
        }
    }
    
    return false;
}